module.exports = __webpack_public_path__ + "static/media/220214_locacard.a455fb0c.jpg";